import { render, staticRenderFns } from "./TpmsTab.vue?vue&type=template&id=31e6cbc7"
import script from "./TpmsTab.vue?vue&type=script&lang=js"
export * from "./TpmsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports